var map = {
	"./aparthotelclub/ic_tag_price.png": 72301,
	"./beachful/ic_tag_price.png": 85871,
	"./castlepedia/ic_tag_price.png": 71799,
	"./cocktayl/ic_tag_price.png": 29006,
	"./ic_tag_price.png": 24477,
	"./luxresortclub/ic_tag_price.png": 17379,
	"./parkful/ic_tag_price.png": 29527,
	"./prefabworld/ic_tag_price.png": 68769,
	"./rooftopclub/ic_tag_price.png": 46098,
	"./spaclub/ic_tag_price.png": 89649,
	"./worldcasino/ic_tag_price.png": 4887,
	"./zoopedia/ic_tag_price.png": 97874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57547;